import SupplierIcon from "@mui/icons-material/Handshake";
import { useSelector } from "react-redux";
import { selectors as suppliersSelectors } from "../../redux/suppliers";
import BaseTag from "./BaseTag";

const SupTag = (props) => {
  const entity = useSelector((state) =>
    suppliersSelectors.selectById(state, props.value),
  );
  const label = props.value === "__is_null" ? "No-Supplier" : entity?.name;
  return <BaseTag icon={<SupplierIcon />} label={label} />;
};

export default SupTag;
